window.addEventListener('unhandledrejection', ({ promise, reason }) => {
  console.error('Unhandled rejection (promise: ', promise, ', reason: ', reason, ').');
});
